// Demo data for marketing demo mode
// Pre-populated sample data for prospects to explore

const today = new Date();
const formatDate = (daysOffset) => {
  const date = new Date(today);
  date.setDate(date.getDate() + daysOffset);
  return date.toISOString();
};

// Demo Customers
export const demoCustomers = [
  {
    id: "demo-customer-1",
    name: "Sarah Mitchell",
    email: "sarah.mitchell@email.com",
    phoneNumber: "(555) 123-4567",
    address: {
      street: "1234 Oak Avenue",
      city: "Austin",
      state: "TX",
      zip: "78701"
    },
    createdAt: formatDate(-60)
  },
  {
    id: "demo-customer-2",
    name: "James Rodriguez",
    email: "j.rodriguez@company.com",
    phoneNumber: "(555) 234-5678",
    address: {
      street: "567 Pine Street",
      city: "Austin",
      state: "TX",
      zip: "78702"
    },
    createdAt: formatDate(-45)
  },
  {
    id: "demo-customer-3",
    name: "Emily Chen",
    email: "emily.chen@business.org",
    phoneNumber: "(555) 345-6789",
    address: {
      street: "890 Maple Drive",
      city: "Round Rock",
      state: "TX",
      zip: "78664"
    },
    createdAt: formatDate(-30)
  },
  {
    id: "demo-customer-4",
    name: "Michael Thompson",
    email: "m.thompson@gmail.com",
    phoneNumber: "(555) 456-7890",
    address: {
      street: "321 Cedar Lane",
      city: "Austin",
      state: "TX",
      zip: "78703"
    },
    createdAt: formatDate(-20)
  },
  {
    id: "demo-customer-5",
    name: "Lisa Anderson",
    email: "lisa.a@outlook.com",
    phoneNumber: "(555) 567-8901",
    address: {
      street: "654 Birch Court",
      city: "Georgetown",
      state: "TX",
      zip: "78626"
    },
    createdAt: formatDate(-10)
  }
];

// Demo Employees
export const demoEmployees = [
  {
    id: "demo-employee-1",
    name: "Alex Martinez",
    email: "alex.m@effitrack.com",
    role: "Technician",
    phone: "(555) 111-2222",
    status: "active"
  },
  {
    id: "demo-employee-2",
    name: "Jordan Smith",
    email: "jordan.s@effitrack.com",
    role: "Senior Technician",
    phone: "(555) 222-3333",
    status: "active"
  },
  {
    id: "demo-employee-3",
    name: "Casey Williams",
    email: "casey.w@effitrack.com",
    role: "Project Manager",
    phone: "(555) 333-4444",
    status: "active"
  }
];

// Demo Tasks
export const demoTasks = [
  {
    id: "demo-task-1",
    title: "HVAC Installation - Mitchell Residence",
    description: "Complete installation of new central AC unit. Customer requested quiet operation model.",
    dueDate: formatDate(1),
    status: "pending",
    priority: "High",
    assignedTo: "demo-employee-1",
    assignedToName: "Alex Martinez",
    customerId: "demo-customer-1",
    customerName: "Sarah Mitchell",
    customerEmail: "sarah.mitchell@email.com",
    customerPhone: "(555) 123-4567",
    customerAddress: {
      street: "1234 Oak Avenue",
      city: "Austin",
      state: "TX",
      zip: "78701"
    },
    adminComments: [],
    employeeComments: [],
    createdAt: formatDate(-2)
  },
  {
    id: "demo-task-2",
    title: "Plumbing Repair - Rodriguez Office",
    description: "Fix leaking pipes in break room. Water damage assessment needed.",
    dueDate: formatDate(0),
    status: "in_progress",
    priority: "High",
    assignedTo: "demo-employee-2",
    assignedToName: "Jordan Smith",
    customerId: "demo-customer-2",
    customerName: "James Rodriguez",
    customerEmail: "j.rodriguez@company.com",
    customerPhone: "(555) 234-5678",
    customerAddress: {
      street: "567 Pine Street",
      city: "Austin",
      state: "TX",
      zip: "78702"
    },
    adminComments: [
      { text: "Priority customer - quick turnaround needed", author: "Admin", timestamp: formatDate(-1) }
    ],
    employeeComments: [],
    createdAt: formatDate(-3)
  },
  {
    id: "demo-task-3",
    title: "Electrical Inspection - Chen Home",
    description: "Annual electrical safety inspection. Check all outlets and panel.",
    dueDate: formatDate(3),
    status: "pending",
    priority: "Medium",
    assignedTo: "demo-employee-1",
    assignedToName: "Alex Martinez",
    customerId: "demo-customer-3",
    customerName: "Emily Chen",
    customerEmail: "emily.chen@business.org",
    customerPhone: "(555) 345-6789",
    customerAddress: {
      street: "890 Maple Drive",
      city: "Round Rock",
      state: "TX",
      zip: "78664"
    },
    adminComments: [],
    employeeComments: [],
    createdAt: formatDate(-1)
  },
  {
    id: "demo-task-4",
    title: "Roof Repair - Thompson Property",
    description: "Repair storm damage on south-facing roof section. Replace damaged shingles.",
    dueDate: formatDate(5),
    status: "pending",
    priority: "Medium",
    assignedTo: "demo-employee-3",
    assignedToName: "Casey Williams",
    customerId: "demo-customer-4",
    customerName: "Michael Thompson",
    customerEmail: "m.thompson@gmail.com",
    customerPhone: "(555) 456-7890",
    customerAddress: {
      street: "321 Cedar Lane",
      city: "Austin",
      state: "TX",
      zip: "78703"
    },
    adminComments: [],
    employeeComments: [],
    createdAt: formatDate(-4)
  },
  {
    id: "demo-task-5",
    title: "Landscaping Project - Anderson Estate",
    description: "Complete backyard renovation including new irrigation system and patio installation.",
    dueDate: formatDate(7),
    status: "pending",
    priority: "Low",
    assignedTo: "demo-employee-2",
    assignedToName: "Jordan Smith",
    customerId: "demo-customer-5",
    customerName: "Lisa Anderson",
    customerEmail: "lisa.a@outlook.com",
    customerPhone: "(555) 567-8901",
    customerAddress: {
      street: "654 Birch Court",
      city: "Georgetown",
      state: "TX",
      zip: "78626"
    },
    adminComments: [],
    employeeComments: [],
    createdAt: formatDate(-5)
  }
];

// Demo Bookings
export const demoBookings = [
  {
    id: "demo-booking-1",
    bookingNumber: "BK-112324-001",
    bookingName: "AC System Installation",
    customerId: "demo-customer-1",
    customerName: "Sarah Mitchell",
    assignedTo: "demo-employee-1",
    assignedToName: "Alex Martinez",
    startDate: formatDate(1),
    date: formatDate(1),
    title: "AC System Installation",
    price: 4500,
    products: [
      { productId: "p1", productName: "Central AC Unit", description: "High-efficiency 3-ton unit", quantity: 1, unitPrice: 3200 }
    ],
    services: [
      { serviceId: "s1", serviceName: "Installation Labor", description: "Professional installation", quantity: 8, unitPrice: 125 },
      { serviceId: "s2", serviceName: "Ductwork Modification", description: "Minor duct adjustments", quantity: 1, unitPrice: 300 }
    ],
    subtotal: 4500,
    total: 4500,
    status: "confirmed",
    createdAt: formatDate(-5),
    updatedAt: formatDate(-2)
  },
  {
    id: "demo-booking-2",
    bookingNumber: "BK-112324-002",
    bookingName: "Emergency Plumbing Service",
    customerId: "demo-customer-2",
    customerName: "James Rodriguez",
    assignedTo: "demo-employee-2",
    assignedToName: "Jordan Smith",
    startDate: formatDate(0),
    date: formatDate(0),
    title: "Emergency Plumbing Service",
    price: 850,
    products: [
      { productId: "p2", productName: "Pipe Fitting Kit", description: "Commercial grade fittings", quantity: 1, unitPrice: 150 }
    ],
    services: [
      { serviceId: "s3", serviceName: "Emergency Service Call", description: "Priority response", quantity: 1, unitPrice: 200 },
      { serviceId: "s4", serviceName: "Plumbing Labor", description: "Repair work", quantity: 4, unitPrice: 125 }
    ],
    subtotal: 850,
    total: 850,
    status: "confirmed",
    createdAt: formatDate(-2),
    updatedAt: formatDate(-1)
  },
  {
    id: "demo-booking-3",
    bookingNumber: "BK-112324-003",
    bookingName: "Electrical Safety Inspection",
    customerId: "demo-customer-3",
    customerName: "Emily Chen",
    assignedTo: "demo-employee-1",
    assignedToName: "Alex Martinez",
    startDate: formatDate(3),
    date: formatDate(3),
    title: "Electrical Safety Inspection",
    price: 350,
    products: [],
    services: [
      { serviceId: "s5", serviceName: "Inspection Service", description: "Complete home inspection", quantity: 1, unitPrice: 350 }
    ],
    subtotal: 350,
    total: 350,
    status: "pending",
    createdAt: formatDate(-3),
    updatedAt: formatDate(-3)
  },
  {
    id: "demo-booking-4",
    bookingNumber: "BK-112324-004",
    bookingName: "Roof Repair Project",
    customerId: "demo-customer-4",
    customerName: "Michael Thompson",
    assignedTo: "demo-employee-3",
    assignedToName: "Casey Williams",
    startDate: formatDate(5),
    date: formatDate(5),
    title: "Roof Repair Project",
    price: 2800,
    products: [
      { productId: "p3", productName: "Roofing Shingles", description: "Architectural shingles - 10 squares", quantity: 10, unitPrice: 150 }
    ],
    services: [
      { serviceId: "s6", serviceName: "Roofing Labor", description: "Repair and replacement", quantity: 10, unitPrice: 130 }
    ],
    subtotal: 2800,
    total: 2800,
    status: "pending",
    createdAt: formatDate(-4),
    updatedAt: formatDate(-4)
  }
];

// Demo Invoices
export const demoInvoices = [
  {
    id: "demo-invoice-1",
    invoiceNumber: "INV-112324-001",
    customerId: "demo-customer-1",
    customerName: "Sarah Mitchell",
    issueDate: formatDate(-10),
    dueDate: formatDate(20),
    productItems: [
      { productId: "p4", productName: "Water Heater", description: "50-gallon tankless unit", quantity: 1, unitPrice: 1800 }
    ],
    serviceItems: [
      { serviceId: "s7", serviceName: "Installation", description: "Professional installation", quantity: 4, unitPrice: 125 }
    ],
    subtotal: 2300,
    taxRate: 8.25,
    taxAmount: 189.75,
    grossTotal: 2489.75,
    discount: 0,
    discountType: "amount",
    discountAmount: 0,
    deposit: 500,
    total: 1989.75,
    notes: "Thank you for your business!",
    terms: "Payment due within 30 days",
    status: "Unpaid",
    emailed: true,
    emailedAt: formatDate(-10),
    createdAt: formatDate(-10),
    updatedAt: formatDate(-10)
  },
  {
    id: "demo-invoice-2",
    invoiceNumber: "INV-112324-002",
    customerId: "demo-customer-3",
    customerName: "Emily Chen",
    issueDate: formatDate(-20),
    dueDate: formatDate(-5),
    productItems: [],
    serviceItems: [
      { serviceId: "s8", serviceName: "Consultation", description: "Project planning", quantity: 2, unitPrice: 150 },
      { serviceId: "s9", serviceName: "Site Survey", description: "Property assessment", quantity: 1, unitPrice: 200 }
    ],
    subtotal: 500,
    taxRate: 8.25,
    taxAmount: 41.25,
    grossTotal: 541.25,
    discount: 10,
    discountType: "percent",
    discountAmount: 50,
    deposit: 0,
    total: 491.25,
    notes: "Thank you for choosing our services!",
    terms: "Payment due within 30 days",
    status: "Paid",
    emailed: true,
    emailedAt: formatDate(-20),
    createdAt: formatDate(-20),
    updatedAt: formatDate(-6)
  },
  {
    id: "demo-invoice-3",
    invoiceNumber: "INV-112324-003",
    customerId: "demo-customer-5",
    customerName: "Lisa Anderson",
    issueDate: formatDate(-5),
    dueDate: formatDate(25),
    productItems: [
      { productId: "p5", productName: "Irrigation Kit", description: "Complete sprinkler system", quantity: 1, unitPrice: 1200 },
      { productId: "p6", productName: "Patio Pavers", description: "Natural stone - 200 sq ft", quantity: 200, unitPrice: 8 }
    ],
    serviceItems: [
      { serviceId: "s10", serviceName: "Landscaping Labor", description: "Installation work", quantity: 16, unitPrice: 85 }
    ],
    subtotal: 3960,
    taxRate: 8.25,
    taxAmount: 326.70,
    grossTotal: 4286.70,
    discount: 200,
    discountType: "amount",
    discountAmount: 200,
    deposit: 1000,
    total: 3086.70,
    notes: "Project includes 1-year warranty on all installations",
    terms: "50% deposit required, balance due upon completion",
    status: "Unpaid",
    emailed: true,
    emailedAt: formatDate(-5),
    createdAt: formatDate(-5),
    updatedAt: formatDate(-5)
  }
];

// Demo Estimates
export const demoEstimates = [
  {
    id: "demo-estimate-1",
    estimateNumber: "EST-112324-001",
    customerId: "demo-customer-2",
    customerName: "James Rodriguez",
    issueDate: formatDate(-3),
    dueDate: formatDate(27),
    products: [
      { description: "Commercial HVAC Unit", unitPrice: 8500, quantity: 1, lineTotal: 8500 }
    ],
    services: [
      { description: "Installation & Setup", unitPrice: 150, quantity: 20, lineTotal: 3000 },
      { description: "Ductwork Installation", unitPrice: 2500, quantity: 1, lineTotal: 2500 }
    ],
    subtotal: 14000,
    taxRate: 8.25,
    taxAmount: 1155,
    grossTotal: 15155,
    discount: 500,
    discountType: "amount",
    discountAmount: 500,
    deposit: 3000,
    total: 11655,
    notes: "Estimate valid for 30 days. Includes 2-year parts warranty.",
    terms: "50% deposit to begin work, balance due on completion",
    status: "Sent",
    emailed: true,
    emailedAt: formatDate(-3),
    createdAt: formatDate(-3)
  },
  {
    id: "demo-estimate-2",
    estimateNumber: "EST-112324-002",
    customerId: "demo-customer-4",
    customerName: "Michael Thompson",
    issueDate: formatDate(-7),
    dueDate: formatDate(23),
    products: [
      { description: "Premium Roofing Shingles", unitPrice: 180, quantity: 15, lineTotal: 2700 },
      { description: "Underlayment Material", unitPrice: 400, quantity: 1, lineTotal: 400 }
    ],
    services: [
      { description: "Roof Tear-off & Disposal", unitPrice: 800, quantity: 1, lineTotal: 800 },
      { description: "Installation Labor", unitPrice: 150, quantity: 12, lineTotal: 1800 }
    ],
    subtotal: 5700,
    taxRate: 8.25,
    taxAmount: 470.25,
    grossTotal: 6170.25,
    discount: 0,
    discountType: "amount",
    discountAmount: 0,
    deposit: 1500,
    total: 4670.25,
    notes: "Price includes removal of old roofing and disposal fees.",
    terms: "Deposit required to schedule, balance due upon completion",
    status: "Accepted",
    emailed: true,
    emailedAt: formatDate(-7),
    createdAt: formatDate(-7)
  }
];

// Demo Products
export const demoProducts = [
  {
    id: "demo-product-1",
    productName: "Central AC Unit",
    productCode: "HVAC-001",
    description: "High-efficiency 3-ton central air conditioning unit",
    unitPrice: 3200,
    category: "HVAC",
    inStock: 5
  },
  {
    id: "demo-product-2",
    productName: "Water Heater",
    productCode: "PLB-001",
    description: "50-gallon tankless water heater",
    unitPrice: 1800,
    category: "Plumbing",
    inStock: 3
  },
  {
    id: "demo-product-3",
    productName: "Roofing Shingles",
    productCode: "ROOF-001",
    description: "Architectural shingles per square",
    unitPrice: 150,
    category: "Roofing",
    inStock: 100
  },
  {
    id: "demo-product-4",
    productName: "Irrigation Kit",
    productCode: "LAND-001",
    description: "Complete sprinkler system kit",
    unitPrice: 1200,
    category: "Landscaping",
    inStock: 8
  },
  {
    id: "demo-product-5",
    productName: "LED Panel Light",
    productCode: "ELEC-001",
    description: "Commercial LED panel 2x4",
    unitPrice: 125,
    category: "Electrical",
    inStock: 50
  }
];

// Demo Services
export const demoServices = [
  {
    id: "demo-service-1",
    serviceName: "Installation Labor",
    serviceCode: "SVC-001",
    description: "Standard installation labor per hour",
    unitPrice: 125,
    category: "Labor"
  },
  {
    id: "demo-service-2",
    serviceName: "Emergency Service Call",
    serviceCode: "SVC-002",
    description: "Priority emergency response",
    unitPrice: 200,
    category: "Emergency"
  },
  {
    id: "demo-service-3",
    serviceName: "Inspection Service",
    serviceCode: "SVC-003",
    description: "Complete system inspection",
    unitPrice: 350,
    category: "Inspection"
  },
  {
    id: "demo-service-4",
    serviceName: "Consultation",
    serviceCode: "SVC-004",
    description: "Project consultation per hour",
    unitPrice: 150,
    category: "Consulting"
  },
  {
    id: "demo-service-5",
    serviceName: "Maintenance Contract",
    serviceCode: "SVC-005",
    description: "Annual maintenance plan",
    unitPrice: 500,
    category: "Maintenance"
  }
];

// Demo Expenses
export const demoExpenses = [
  {
    id: "demo-expense-1",
    description: "Vehicle Fuel",
    amount: 450,
    category: "Transportation",
    date: formatDate(-5),
    vendor: "Shell Gas Station",
    paymentMethod: "Company Card",
    status: "Approved"
  },
  {
    id: "demo-expense-2",
    description: "Tool Purchase",
    amount: 380,
    category: "Equipment",
    date: formatDate(-10),
    vendor: "Home Depot",
    paymentMethod: "Company Card",
    status: "Approved"
  },
  {
    id: "demo-expense-3",
    description: "Office Supplies",
    amount: 125,
    category: "Office",
    date: formatDate(-3),
    vendor: "Staples",
    paymentMethod: "Petty Cash",
    status: "Pending"
  }
];

// Demo Suppliers
export const demoSuppliers = [
  {
    id: "demo-supplier-1",
    name: "Austin HVAC Supply",
    email: "orders@austinhvac.com",
    phone: "(512) 555-1000",
    address: "100 Industrial Blvd, Austin, TX 78701",
    category: "HVAC",
    paymentTerms: "Net 30"
  },
  {
    id: "demo-supplier-2",
    name: "Texas Plumbing Wholesale",
    email: "sales@txplumbing.com",
    phone: "(512) 555-2000",
    address: "200 Warehouse Way, Austin, TX 78702",
    category: "Plumbing",
    paymentTerms: "Net 15"
  },
  {
    id: "demo-supplier-3",
    name: "Lone Star Roofing Materials",
    email: "info@lonestarroof.com",
    phone: "(512) 555-3000",
    address: "300 Construction Ave, Round Rock, TX 78664",
    category: "Roofing",
    paymentTerms: "Net 30"
  }
];

// Demo Stats (computed summary)
export const demoStats = {
  totalRevenue: 8567.70,
  pendingInvoices: 5076.45,
  bookingsThisWeek: 4,
  activeCustomers: 5,
  tasksCompleted: 12,
  tasksPending: 5,
  employeesActive: 3
};

// Demo Business Profile
export const demoBusinessProfile = {
  businessName: "EffiTrack Demo Co.",
  email: "demo@effitrack.com",
  phone: "(555) 000-0000",
  address: {
    street: "123 Demo Street",
    city: "Austin",
    state: "TX",
    zip: "78701"
  },
  website: "https://effitrack.com",
  logo: null
};

export default {
  customers: demoCustomers,
  employees: demoEmployees,
  tasks: demoTasks,
  bookings: demoBookings,
  invoices: demoInvoices,
  estimates: demoEstimates,
  products: demoProducts,
  services: demoServices,
  expenses: demoExpenses,
  suppliers: demoSuppliers,
  stats: demoStats,
  businessProfile: demoBusinessProfile
};
